<h3 class="ui-headline">{{ 'account.personal-information.labels.address' | translate }}</h3>
<form #addressFormDirective="ngForm" [formGroup]="addressForm" (ngSubmit)="onAddressSubmit()">
  <div class="address-holder">
    <!-- Street -->
    <div class="input-box">
      <label for="profile-street">{{ 'account.personal-information.labels.street' | translate }}</label>
      <input
        id="profile-street"
        type="text"
        placeholder="{{ 'account.personal-information.labels.street' | translate }}"
        class="required"
        formControlName="street"
      />
    </div>
    <!--End Street -->
    <!-- Number -->
    <div class="input-box small">
      <label for="profile-number">{{ 'account.personal-information.labels.number' | translate }}</label>
      <input
        id="profile-number"
        type="text"
        placeholder="{{ 'account.personal-information.labels.number' | translate }}"
        class="required"
        formControlName="number"
      />
      <p class="error empty" *ngIf="addressFormDirective.submitted && numberControl?.invalid && streetControl?.valid">
        {{ 'account.personal-information.error.number' | translate }}
      </p>
    </div>
    <!--End Number -->
    <p class="error empty" *ngIf="addressFormDirective.submitted && streetControl?.invalid && numberControl?.valid">
      {{ 'account.personal-information.error.street' | translate }}
    </p>
    <p class="error empty" *ngIf="addressFormDirective.submitted && streetControl?.invalid && numberControl?.invalid">
      {{ 'account.personal-information.error.streetAndNumber' | translate }}
    </p>
  </div>

  <!--/.address-holder-->
  <div class="address-holder">
    <!-- Zip Code -->
    <div class="input-box small">
      <label for="profile-postal">{{ 'account.personal-information.labels.zip' | translate }}</label>
      <input
        id="profile-postal"
        type="text"
        placeholder="{{ 'account.personal-information.labels.zip' | translate }}"
        class="required"
        formControlName="zip"
      />
    </div>
    <!--End Zip Code -->
    <!-- City -->
    <div class="input-box profile-city">
      <label for="profile-city">{{ 'account.personal-information.labels.city' | translate }}</label>
      <input
        id="profile-city"
        type="text"
        placeholder="{{ 'account.personal-information.labels.city' | translate }}"
        formControlName="city"
      />
      <p class="error empty" *ngIf="addressFormDirective.submitted && cityControl?.invalid && zipControl?.valid">
        {{ 'account.personal-information.error.city' | translate }}
      </p>
    </div>
    <!--End City -->
    <p class="error empty" *ngIf="addressFormDirective.submitted && zipControl?.hasError('required')">
      {{ 'account.personal-information.error.zip' | translate }}
    </p>
    <p class="error empty" *ngIf="addressFormDirective.submitted && zipControl?.hasError('validZip')">
      {{ 'account.personal-information.error.validZip' | translate }}
    </p>
  </div>
  <!--/.profile-box-->
  <div class="address-holder">
    <!-- Country -->
    <div class="input-box">
      <div>
        <label>{{ 'account.personal-information.labels.country' | translate }}</label>
        <app-ui-tooltip color="yellow" size="small">
          <span [innerHtml]="'profile.personal-information.tooltips.country' | translate"></span>
          <a routerLink="/help">
            {{ 'profile.personal-information.tooltips.customer-link' | translate }}
          </a>
        </app-ui-tooltip>
        <div>
          <select disabled class="form-control profile-country" [class.valid]="countryControl?.value !== ''">
            <option value="" disabled hidden data-default>{{ 'account.personal-information.labels.country' | translate }}</option>
            <option
              *ngFor="let country of countries$ | async"
              [value]="country.ISO_CODE_2"
              [selected]="country.ISO_CODE_2 === countryControl?.value"
            >
              {{ country.id }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <!-- End Country -->
  </div>
  <!-- Actions -->
  <div class="ui-button-group">
    <button type="submit" class="ui-button" [class.loading]="addressUpdateLoading$ | async">
      <span class="icon-i-windmill"></span>
      {{ 'personal.send' | translate }}
    </button>
    <button (click)="onDiscardChanges()" class="ui-button-text">
      <span>{{ 'modals.consultation.cta.cancel' | translate }}</span>
    </button>
  </div>
  <!-- End Actions-->
</form>
